var React = require('react');

function NoteLrg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.14601 44C6.84379 44.001 6.55266 43.882 6.33798 43.6693C6.12382 43.4571 6.00235 43.1687 6.00001 42.8673L6 42.8657L6.00001 7.13038C6.00001 6.50702 6.50703 6 7.13039 6H42.8696C43.479 6 44 6.51751 44 7.15047V31.2453L31.2456 43.9912L7.15104 44L7.14601 44ZM28.3175 41.708V29.4635C28.3176 29.1829 28.4206 28.912 28.6071 28.7023C28.7856 28.5015 29.0287 28.3701 29.2936 28.3304L29.3031 28.329L29.5024 28.3171L41.708 28.315V8.29201H8.29201V41.708H28.3175ZM13.717 17.0014V14.6447H36.2844V17.0014H13.717ZM13.717 22.7147V20.358H36.2844V22.7147H13.717ZM13.717 28.428V26.0713H24.1437V28.428H13.717ZM13.717 34.1413V31.7845H20.5729V34.1413H13.717ZM41.9123 30.392L30.3953 30.3957V41.9054L41.9123 30.392Z","fill":"#656976"}));
}

NoteLrg.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = NoteLrg;

NoteLrg.default = NoteLrg;
